module.exports = __webpack_public_path__ + "img/Lisensi-RemitPro.1d552fd7.webp";